import type { AxiosInstance } from 'axios'
import type {
  CommonHeaders,
  CustomAxiosRequestConfig
} from 'types/commons/model'
import { handleError } from './error-handler'
import { getCommonHeaders } from './utilities.client-helper'

export const addAxiosCommonInterceptors = (axios: AxiosInstance) => {
  axios.interceptors.request.use((config) => {
    const headers: CommonHeaders = getCommonHeaders()
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    Object.keys(headers).map((e) => config.headers.set(e, headers[e]))
    return config
  })
  axios.interceptors.response.use(
    (response) => response,
    async (error) => {
      const config = error.config as CustomAxiosRequestConfig
      if (config?.skipErrorAlert) {
        return await Promise.reject(error)
      }

      handleError(error?.response?.data)
      return await Promise.reject(error)
    }
  )
}
